<template>
    <div class="popup rd-fragment rd-deposit-modal" :class="classObj">
        <van-popup :value="show" @click-overlay="close" @open="open">
            <div class="content">

                <div class="Deposit">
                    <statusBar></statusBar>
                    <div class="header">
                        <div>{{ $t("deposit.Deposit") }}</div>
                        <div class="close">
                            <i class="iconfont icon-s-cuowu-guanbi" @click="close"></i>
                        </div>
                    </div>
                    <div class="Deposit-main">
                        <div class="first-Deposit">
                            <div class="btn" @click="toTutorial" v-if="depositType === 'TransferDeposit'">{{
                                $t("deposit.Tutorial") }}</div>
                            <div class="btn" v-else>
                                {{ $t("deposit.FirstDeposit") }}
                            </div>
                            <div v-if="showBonus && ((depositType === 'TransferDeposit' && showUsdtRepeatBouns) || (depositType === 'OnlineDeposit' && showRepeatBouns))">
                                <div class="txt">
                                    <div v-if="rewardPercentage1">{{ rewardPercentageTxt1 }} <span v-if="rewardFS">{{ ',+' + rewardFS + 'FS' }}</span></div>
                                    <div v-if="rewardPercentage2">{{ rewardPercentageTxt2 }} <span v-if="rewardFS">{{ ',+' + rewardFS + 'FS' }}</span></div>
                                    <div v-if="rewardPercentage3">{{ rewardPercentageTxt3 }} <span v-if="rewardFS">{{ ',+' + rewardFS + 'FS' }}</span></div>
                                </div>
                            </div>
                            <div class="detail" @click="$refs.depositRulesPopup.open()">{{ $t("deposit.Details") }}
                            </div>
                        </div>
                        <div class="tab">
                            <div class="tab__item" :class="{ 'act': item.value === depositType }"
                                v-for="(item) in depositTypes" :key="item.value" @click="changeDepositType(item)">
                                <i class="iconfont " :class="[item.icon]"></i>
                                <span>{{ item.name }}</span>
                            </div>
                        </div>
                        <div class="PaymentMethods-App" v-if="!isShowPayList">
                            <div class="DepositMethods-title">{{ $t("deposit.DepositMethods") }}</div>
                            <div class="DepositMethods-selected" @click="isShowPayList = true">
                                <div class="info">
                                    <img :src="payListImg" />
                                    <div>{{ payListName }}</div>
                                </div>
                                <div class="change">{{ $t("deposit.Change") }}</div>
                            </div>
                        </div>
                        <div class="PaymentMethods" :class="{ 'act': isShowPayList }">
                            <div class="DepositMethods-header">
                                <language :show="true" :showIcon="true"></language>
                                <div>
                                    <div>{{ $t("deposit.PaymentMethodsRregion") }}</div>
                                    <div>{{ payListName }}</div>
                                </div>
                            </div>
                            <div class="DepositMethods-box">
                                <div class="DepositMethods-title">{{ $t("deposit.DepositMethods") }}</div>
                                <div class="DepositMethods-list">
                                    <div class="DepositMethods-item" :class="{ 'act': item.id === payListId }"
                                        v-for="(item, index) in payList" :key="index" @click="handlePayListItemClick(item)">
                                        <img :src="item.imgUrl" />
                                        <div>{{ item.name || item.showName }}</div>
                                        <img v-if="item.isHot == 'Yes'" class="DepositMethods-item-hot" src="@/assets/deposit/icon_hot.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <template v-if="depositType === 'TransferDeposit'">
                            <div class="DepositContent" :class="{ 'hide': isShowPayList }">
                                <div class="amount_input">
                                    <div class="Recharge-Limt">{{ minRechargeAmt }} - {{ maxRechargeAmt }} U </div>
                                    <a-input v-model="usdtRechargeValue" type="number"
                                        :placeholder="$t('deposit.Amount') + '(U)'" @change="handleRechargeChange">
                                        <div v-if="rewardPercentage && showBonus && showUsdtRepeatBouns" slot="suffix" class="extra">
                                            {{ $t("deposit.Extra") }} + U {{ rewardPercentage }}
                                            <span v-if="rewardFS">{{ ', +' + rewardFS + 'FS' }}</span>
                                        </div>
                                        <div v-else slot="suffix" class="noBonus">
                                            {{ $t("deposit.noBonus") }}
                                        </div>
                                    </a-input>
                                </div>
                                <div class="exchangeRate">
                                    <div class="exchangeRate_left">
                                        <div>{{ $t('deposit.ExchangeRate') }}</div>
                                        <div>
                                            <span>U1 : {{ CurrencyType }}{{ changeRate }}</span>
                                            <span class="iconfont icon-shuaxin" @click="getRate"></span>
                                        </div>
                                    </div>
                                    <div class="exchangeRate_right">
                                        <div>
                                            <div>{{ $t('deposit.Deposit') }}</div>
                                            <div>≈{{ rateMoney }}{{ currency }}</div>
                                        </div>
                                        <div v-if="rewardPercentage && showBonus && showUsdtRepeatBouns">
                                            <div>{{ $t('deposit.Bonus') }}</div>
                                            <div>≈{{ rateBonus }}{{ currency }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="usdtList && usdtList.length" class="form_gap" style="margin-top: .01rem;">
                                    <div class="form_gap_item" :class="{ 'act': item.rechargeAmt == usdtRechargeValue }"
                                        v-for="(item, index) in usdtList" :key="index"
                                        @click="handleUsdtListItemClick(item)">
                                        <div class="num">U {{ item.rechargeAmt }}</div>
                                        <div v-if="showBonus && showUsdtRepeatBouns" style="margin-top: .08rem;">
                                            <!-- <div v-if="item.extraMoney" class="extra">+{{ CurrencyType }}{{ item.extraMoney }} +{{ item.freePayNumber }}FS</div> -->
                                            <div v-if="item.bonusPercent" class="extra">+{{ item.bonusPercent }}%</div>
                                            <div v-if="item.freePayNumber && usdtRepeatIsFreeRounds == 'Yes'" class="extra">+{{ item.freePayNumber }}FS</div>
                                        </div>
                                    </div>
                                </div>
                                <a-button class="submit-btn" @click="handleUsdtRecharge">{{
                                    $t("deposit.Deposit") }}</a-button>
                                <a-button class="submit-btn toTransaction" @click="toTransaction">{{
                                    $t("Transaction.Transaction") }}</a-button>
                                <div class="showBonus">
                                    <div class="check-box" @click="showBonus = !showBonus">
                                        <i v-if="!showBonus" class="iconfont icon-xuanzeyixuanze checked"></i>
                                        <i v-else class="iconfont icon-a-xuanzeweixuanze"></i>
                                    </div>
                                    <div class="tips">{{ $t("deposit.showBonusTips") }}</div>
                                </div>
                                <div v-if="rulesDesc" class="rulesDesc">
                                    <div v-html="rulesDesc"></div>
                                </div>
                            </div>
                        </template>
                        <template v-if="depositType === 'OnlineDeposit'">
                            <div class="DepositContent" :class="{ 'hide': isShowPayList }">
                                <div v-if="BelongNation !== 'USA' && BelongNation !== 'Russia'" class="amount_input">
                                    <div class="Recharge-Limt">
                                        {{ minRechargeAmt }} - {{ maxRechargeAmt }} {{ currency }}
                                    </div>
                                    <a-input v-model="rechargeValue" type="number"
                                        :placeholder="$t('deposit.Amount') + '(' + currency + ')'"
                                        @change="handleRechargeChange">
                                        <div v-if="rewardPercentage && showBonus && showRepeatBouns" slot="suffix" class="extra">
                                            {{ $t("deposit.Extra") }} + {{ CurrencyType }} {{ rewardPercentage }}
                                            <span v-if="rewardFS">{{ ', +' + rewardFS + 'FS' }}</span>
                                        </div>
                                        <div v-else slot="suffix" class="noBonus">
                                            {{ $t("deposit.noBonus") }}
                                        </div>
                                    </a-input>
                                </div>
                                <div class="form_gap">
                                    <div class="form_gap_item" :class="{ 'act': item.rechargeAmt == rechargeValue }"
                                        v-for="(item, index) in RechargeList" :key="index"
                                        @click="handleListItemClick(item)">
                                        <div class="num">{{ CurrencyType }} {{ item.rechargeAmt }}</div>
                                        <div v-if="showBonus && showRepeatBouns" style="margin-top: .08rem;">
                                            <!-- <div v-if="item.extraMoney" class="extra">+{{ CurrencyType }}{{ item.extraMoney }} +{{ item.freePayNumber }}FS</div> -->
                                            <div v-if="item.bonusPercent" class="extra">+{{ item.bonusPercent }}%</div>
                                            <div v-if="item.freePayNumber && repeatIsFreeRounds == 'Yes'" class="extra">+{{ item.freePayNumber }}FS</div>
                                        </div>
                                        <img v-if="item.isHotRecharge === 'Yes'" class="hot" src="@/assets/deposit/icon_hot.png" />
                                    </div>
                                </div>
                                <a-button class="submit-btn" @click="handleRecharge">
                                    {{ $t("deposit.Deposit") }}
                                </a-button>
                                <!-- <div class="tips" style="lineHeight: .3rem;">{{ $t("deposit.DepositTips2") }}</div> -->
                                <div class="showBonus">
                                    <div class="check-box" @click="showBonus = !showBonus">
                                        <i v-if="!showBonus" class="iconfont icon-xuanzeyixuanze checked"></i>
                                        <i v-else class="iconfont icon-a-xuanzeweixuanze"></i>
                                    </div>
                                    <div class="tips">{{ $t("deposit.showBonusTips") }}</div>
                                </div>
                                <div v-if="rulesDesc" class="rulesDesc">
                                    <div v-html="rulesDesc"></div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </van-popup>
        <depositRulesPopup ref="depositRulesPopup"></depositRulesPopup>
        <payDetail ref="payDetail"></payDetail>
        <depositDetail ref="depositDetail" :details="depositDetails" @onContinue="onContinueDeposit"></depositDetail>
        <tipsPopup ref="depositTipsPop" :tips="$t('deposit.DepositTips2')"></tipsPopup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { getRechargeList, createMemberRechargeOrder, getRate, createMemberUsdtRechargeOrder, getUsdtTutorials, getUsdtRechargeOrderByWaitPay } from '@/api/deposit'
import { getUserInfo } from '@/api/user'
import { Toast } from 'vant'
import depositRulesPopup from './depositRulesPopup.vue'
import depositDetail from './depositDetail.vue'
import payDetail from './payDetail.vue'
import statusBar from '@/components/statusBar'
import language from '@/components/language'
import tipsPopup from './tipsPopup.vue'
export default {
    name: 'depositPopup',
    components: { depositRulesPopup, depositDetail, statusBar, language, payDetail, tipsPopup },
    data() {
        return {
            depositType: 'OnlineDeposit',
            depositTypes: [{
                name: this.$t('deposit.OnlineDeposit'),
                key: 'OnlineDeposit',
                value: 'OnlineDeposit',
                icon: 'icon-shoujizhifu'
            }
                // {
                // 	name: 'Transfer Deposit',
                // 	key: 'TransferDeposit',
                // 	value: 'TransferDeposit',
                // 	icon: 'icon-yinxingqia'
                // }
            ],
            rechargeGiftType: '',
            rechargeGiftRewardType: '',
            RechargeList: [],
            repeatIsFreeRounds: '',
            gratuityConditions: '',
            rulesDesc: '',
            isShowPayList: false,
            totalPayList: [],
            payList: [],
            payListId: '',
            payListImg: '',
            payChannelType: '',
            payListName: '',
            rechargeValue: '',
            minRechargeAmt: 0,
            maxRechargeAmt: 0,
            rewardPercentage: 0,
            rewardFS: 0,
            showRepeatBouns: true,
            rewardPercentageAmount1: '',
            rewardPercentageAmount2: '',
            rewardPercentageAmount3: '',
            rewardPercentageTxt1: '',
            rewardPercentageTxt2: '',
            rewardPercentageTxt3: '',
            rewardPercentage1: '',
            rewardPercentage2: '',
            rewardPercentage3: '',
            showBonus: true,
            userInfo: {},
            progress: 0,
            loading: false,
            canCallHandleRecharge: true,

            changeRate: 0,
            usdtRechargeValue: '',
            usdtRechargeGiftType: '',
            usdtRechargeGiftRewardType: '',
            usdtGratuityConditions: '',
            usdtList: [],
            usdtRepeatIsFreeRounds: '',
            depositDetails: {},
            showUsdtRepeatBouns: true
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        currency() {
            const currency = this.$store.getters.sysConfig?.currency
            return currency || ''
        },
        rateMoney() {
            return (Number(this.changeRate || 0) * Number(this.usdtRechargeValue || 0)).toFixed(2)
        },
        rateBonus() {
            return (Number(this.changeRate || 0) * Number(this.rewardPercentage || 0)).toFixed(2)
        },
        show: {
            get() {
                return this.$store.getters.isShowDepositPopup
            },
            set(val) {
                return val
            }
        }
    },
    created() { },
    methods: {
        close() {
            this.isShowPayList = false
            this.$store.dispatch('user/setIsShowDepositPopup', false)
        },
        open() {
            // this.$nextTick(() => {
            //     this.$refs.depositTipsPop.open()
            // })
            getUserInfo().then(res1 => {
                if (res1.code) return
                this.userInfo = res1.result
                const grandRechargeNumber = Number(this.userInfo.grandRechargeNumber) + 1

                getRechargeList().then(res => {
                    if (res.code) {
                        Toast(res.message)
                        return
                    }
                    const D = res.result

                    this.RechargeList = []
                    this.showRepeatBouns = true
                    this.rechargeGiftType = D.rechargeGiftType
                    this.rechargeGiftRewardType = D.rechargeGiftRewardType
                    this.repeatIsFreeRounds = D.repeatIsFreeRounds
                    if (this.rechargeGiftType === 'firstRecharge') {
                        this.RechargeList = D.firstRechargeDetailVoList
                        this.gratuityConditions = D.gratuityConditions
                    }
                    if (this.rechargeGiftType === 'repeatRecharge') {
                        this.RechargeList = D.everyRepeatRechargeDetailVoList
                        if (D && D.repeatRechargeNumberDetailVoList.length) {
                            if (D.repeatRechargeNumberDetailVoList.some(x => Number(x.rechargeNumber) === Number(grandRechargeNumber))) {
                                const repeatRechargeList = D.repeatRechargeNumberDetailVoList.filter(x => Number(x.rechargeNumber) === Number(grandRechargeNumber))[0]
                                this.RechargeList = repeatRechargeList.repeatRechargeDetailVoList
                                if (this.RechargeList && this.RechargeList.length) {
                                    this.RechargeList.forEach(x => {
                                        x.isFreeRounds = repeatRechargeList.isFreeRounds
                                    })
                                }
                            } else {
                                const repeatRechargeList = D.repeatRechargeNumberDetailVoList[D.repeatRechargeNumberDetailVoList.length - 1]
                                this.RechargeList = repeatRechargeList.repeatRechargeDetailVoList
                                this.showRepeatBouns = false
                            }
                        }
                    }
                    this.setRechargeList('RechargeList')

                    this.usdtList = []
                    this.showUsdtRepeatBouns = true
                    this.usdtRechargeGiftType = D.usdtRechargeGiftType
                    this.usdtRechargeGiftRewardType = D.usdtRechargeGiftRewardType
                    this.usdtRepeatIsFreeRounds = D.usdtRepeatIsFreeRounds
                    if (this.usdtRechargeGiftType === 'firstRecharge') {
                        this.usdtList = D.usdtFirstRechargeDetailVoList
                        this.usdtGratuityConditions = D.usdtGratuityConditions
                    }
                    if (this.usdtRechargeGiftType === 'repeatRecharge') {
                        this.usdtList = D.usdtEveryRepeatRechargeDetailVoList
                        if (D && D.usdtRepeatRechargeNumberDetailVoList.length) {
                            if (D.usdtRepeatRechargeNumberDetailVoList.some(x => Number(x.rechargeNumber) === Number(grandRechargeNumber))) {
                                const repeatRechargeList = D.usdtRepeatRechargeNumberDetailVoList.filter(x => Number(x.rechargeNumber) === Number(grandRechargeNumber))[0]
                                this.usdtList = repeatRechargeList.repeatRechargeDetailVoList
                                if (this.usdtList && this.usdtList.length) {
                                    this.usdtList.forEach(x => {
                                        x.isFreeRounds = repeatRechargeList.isFreeRounds
                                    })
                                }
                            } else {
                                const repeatRechargeList = D.usdtRepeatRechargeNumberDetailVoList[D.usdtRepeatRechargeNumberDetailVoList.length - 1]
                                this.usdtList = repeatRechargeList.repeatRechargeDetailVoList
                                this.showUsdtRepeatBouns = false
                            }
                        }
                    }
                    this.setRechargeList('usdtList')

                    this.totalPayList = D.payList.filter(x => x.enableRechargeType === 1 || x.enableRechargeType === 'enable').sort((a, b) => b.sort - a.sort)
                    this.changeDepositType(this.depositTypes[0])
                    this.rulesDesc = D.explainDec
                    this.initDepositTypes()
                    this.getRewardPercentage()
                })
            })
        },
        setRechargeList(key) {
            this[key].forEach((item, i) => {
                if (this.rechargeGiftRewardType === 'immobilization') {
                    if (this.gratuityConditions === 'MAXIMUM' && (item.everyHandselRate || (this.userInfo && this.userInfo.everyFirstRechargeState === 'No' && item.handselRate) || (this.userInfo && this.userInfo.firstRechargeState === 'No' && item.firstHandselRate))) {
                        if (this.userInfo && this.userInfo.firstRechargeState === 'No') {
                            item.extraMoney = item.firstHandselRate > item.handselRate ? (item.firstHandselRate > item.everyHandselRate ? (item.firstHandselRate || 0).toFixed(2) : (item.everyHandselRate || 0).toFixed(2)) : (item.handselRate > item.everyHandselRate ? (item.handselRate || 0).toFixed(2) : (item.everyHandselRate || 0).toFixed(2))
                        } else if (this.userInfo && this.userInfo.everyFirstRechargeState === 'No') {
                            item.extraMoney = item.handselRate > item.everyHandselRate ? (item.handselRate || 0).toFixed(2) : (item.everyHandselRate || 0).toFixed(2)
                        } else {
                            item.extraMoney = (item.everyHandselRate || 0).toFixed(2)
                        }
                    } else if (item.everyHandselRate || (this.userInfo && this.userInfo.everyFirstRechargeState === 'No' && item.handselRate) || (this.userInfo && this.userInfo.firstRechargeState === 'No' && item.firstHandselRate)) {
                        if (this.userInfo && this.userInfo.firstRechargeState === 'No' && item.firstHandselRate) {
                            item.extraMoney = item.handselRate + item.firstHandselRate + item.everyHandselRate
                        } else if (this.userInfo && this.userInfo.everyFirstRechargeState === 'No' && item.handselRate) {
                            item.extraMoney = item.handselRate + item.everyHandselRate
                        } else {
                            item.extraMoney = (item.everyHandselRate || 0).toFixed(2)
                        }
                    }
                    if (item.extraMoney) item.bonusPercent = (Number(item.extraMoney) / Number(item.rechargeAmt) * 100).toFixed(2)
                } else {
                    if (this.gratuityConditions === 'MAXIMUM' && (item.everyHandselRate || (this.userInfo && this.userInfo.everyFirstRechargeState === 'No' && item.handselRate) || (this.userInfo && this.userInfo.firstRechargeState === 'No' && item.firstHandselRate))) {
                        if (this.userInfo && this.userInfo.firstRechargeState === 'No') {
                            item.bonusPercent = item.firstHandselRate > item.handselRate ? (item.firstHandselRate > item.everyHandselRate ? (item.firstHandselRate || 0).toFixed(2) : (item.everyHandselRate || 0).toFixed(2)) : (item.handselRate > item.everyHandselRate ? (item.handselRate || 0).toFixed(2) : (item.everyHandselRate || 0).toFixed(2))
                        } else if (this.userInfo && this.userInfo.everyFirstRechargeState === 'No') {
                            item.bonusPercent = item.handselRate > item.everyHandselRate ? (item.handselRate || 0).toFixed(2) : (item.everyHandselRate || 0).toFixed(2)
                        } else {
                            item.bonusPercent = (item.everyHandselRate || 0).toFixed(2)
                        }
                    } else if (item.everyHandselRate || (this.userInfo && this.userInfo.everyFirstRechargeState === 'No' && item.handselRate) || (this.userInfo && this.userInfo.firstRechargeState === 'No' && item.firstHandselRate)) {
                        if (this.userInfo && this.userInfo.firstRechargeState === 'No' && item.firstHandselRate) {
                            item.bonusPercent = item.handselRate + item.firstHandselRate + item.everyHandselRate
                        } else if (this.userInfo && this.userInfo.everyFirstRechargeState === 'No' && item.handselRate) {
                            item.bonusPercent = item.handselRate + item.everyHandselRate
                        } else {
                            item.bonusPercent = (item.everyHandselRate || 0).toFixed(2)
                        }
                    }
                    if (item.bonusPercent) item.extraMoney = (Number(item.bonusPercent) * Number(item.rechargeAmt) / 100).toFixed(2)
                }
            })
        },
        initDepositTypes() {
            const payList = this.totalPayList.filter(x => x.payChannelType.indexOf('USDT') !== -1 || x.showName.indexOf('USDT') !== -1)
            if (payList && payList.length) {
                this.depositTypes = [{
                    name: this.$t('deposit.OnlineDeposit'),
                    key: 'OnlineDeposit',
                    value: 'OnlineDeposit',
                    icon: 'icon-shoujizhifu'
                },
                {
                    name: this.$t('deposit.TransferDeposit'),
                    key: 'TransferDeposit',
                    value: 'TransferDeposit',
                    icon: 'icon-USDT'
                }]
            }
        },
        changeDepositType(item) {
            this.depositType = item.value
            if (this.depositType === 'TransferDeposit') {
                this.getRate()
                getUsdtRechargeOrderByWaitPay().then((res) => {
                    if (res.code) return
                    const D = res.result
                    this.onShowDetail(D)
                })
                this.payList = this.totalPayList.filter(x => x.payChannelType.indexOf('USDT') !== -1 || x.showName.indexOf('USDT') !== -1)
            } else {
                this.payList = this.totalPayList.filter(x => x.payChannelType.indexOf('USDT') === -1 && x.showName.indexOf('USDT') === -1)
            }
            if (this.payList && this.payList.length) {
                this.payListId = this.payList[0].id
                this.payChannelType = this.payList[0].payChannelType
                this.payListImg = this.payList[0].imgUrl
                this.payListName = this.payList[0].name || this.payList[0].showName
                this.payList.forEach(x => {
                    if (x.id === this.payListId) {
                        this.minRechargeAmt = x.minRechargeAmt || x.minRechargeLimit || 0
                        this.maxRechargeAmt = x.maxRechargeAmt || x.maxRechargeLimit || 0
                    }
                })
            } else {
                this.minRechargeAmt = 0
                this.maxRechargeAmt = 0
                this.payListId = ''
                this.payChannelType = ''
                this.payListName = ''
            }
            this.getRewardPercentage()
        },
        getRate() {
            getRate().then(res => {
                if (res.code) return
                this.changeRate = res.result
            })
        },
        getRewardPercentage() {
            let rechargeValue = 0
            let list = []

            if (this.depositType === 'OnlineDeposit') {
                rechargeValue = this.rechargeValue
                list = this.RechargeList || []
            }
            if (this.depositType === 'TransferDeposit') {
                rechargeValue = this.usdtRechargeValue
                list = this.usdtList || []
            }
            if (Number(rechargeValue) < Number(this.rewardPercentageAmount1)) {
                this.rewardPercentageTxt1 = ''
                this.rewardPercentage1 = ''
            }
            if (Number(rechargeValue) < Number(this.rewardPercentageAmount2)) {
                this.rewardPercentageTxt2 = ''
                this.rewardPercentage2 = ''
            }
            if (Number(rechargeValue) < Number(this.rewardPercentageAmount3)) {
                this.rewardPercentageTxt3 = ''
                this.rewardPercentage3 = ''
            }
            if (!list.length) {
                this.rewardPercentage = 0
                return
            }
            if (rechargeValue < list[0].rechargeAmt) {
                this.rewardPercentage = 0
                return
            }
            if (!this.rewardPercentage1 && !this.rewardPercentage2 && !this.rewardPercentage3) {
                this.rewardPercentage = 0
            }
            for (let i = 0; i < list.length; i++) {
                if (Number(rechargeValue) >= Number(list[i].rechargeAmt)) {
                    if ((i + 1) < list.length) {
                        if (Number(rechargeValue) <= Number(list[i + 1].rechargeAmt)) {
                            let hasEveryReward = 0
                            let hasReward = 0
                            let hasFirstReward = 0
                            let j = Number(i)
                            for (j; j >= 0; j--) {
                                if (!hasEveryReward && list[j].everyHandselRate) {
                                    hasEveryReward = list[j].everyHandselRate
                                    this.getRP(list[j], 'EveryReward')
                                }
                                if (!hasReward && list[j].handselRate) {
                                    hasReward = list[j].handselRate
                                    this.getRP(list[j], 'Reward')
                                }
                                if (!hasFirstReward && list[j].firstHandselRate) {
                                    hasFirstReward = list[j].firstHandselRate
                                    this.getRP(list[j], 'FirstReward')
                                }
                            }
                        }
                    } else {
                        let hasEveryReward = 0
                        let hasReward = 0
                        let hasFirstReward = 0
                        let j = Number(i)
                        for (j; j >= 0; j--) {
                            if (!hasEveryReward && list[j].everyHandselRate) {
                                hasEveryReward = list[j].everyHandselRate
                                this.getRP(list[j], 'EveryReward')
                            }
                            if (!hasReward && list[j].handselRate) {
                                hasReward = list[j].handselRate
                                this.getRP(list[j], 'Reward')
                            }
                            if (!hasFirstReward && list[j].firstHandselRate) {
                                hasFirstReward = list[j].firstHandselRate
                                this.getRP(list[j], 'FirstReward')
                            }
                        }
                    }
                }
            }
        },
        getRP(x, type) {
            let rechargeValue = 0
            let gratuityConditions = 'TOTAL'
            let rechargeGiftRewardType = 'scale'
            let repeatIsFreeRounds = ''
            if (this.depositType === 'OnlineDeposit') {
                rechargeValue = this.rechargeValue
                gratuityConditions = this.gratuityConditions
                rechargeGiftRewardType = this.rechargeGiftRewardType
                repeatIsFreeRounds = this.repeatIsFreeRounds
            }
            if (this.depositType === 'TransferDeposit') {
                rechargeValue = this.usdtRechargeValue
                gratuityConditions = this.usdtGratuityConditions
                rechargeGiftRewardType = this.usdtRechargeGiftRewardType
                repeatIsFreeRounds = this.usdtRepeatIsFreeRounds
            }
            this.rewardPercentage = ''
            if (rechargeGiftRewardType === 'immobilization') {
                if (this.userInfo && this.userInfo.firstRechargeState === 'No') {
                    if (x.everyHandselRate && type === 'EveryReward') {
                        this.rewardPercentageTxt1 = this.$t('Withdraw.rewardPercentageTxt1_1') + x.rechargeAmt + this.$t('Withdraw.rewardPercentageTxt1_2') + this.CurrencyType + x.everyHandselRate
                        this.rewardPercentage1 = x.everyHandselRate
                        this.rewardPercentageAmount1 = x.rechargeAmt
                    }
                    if (x.handselRate && type === 'Reward') {
                        this.rewardPercentageTxt2 = this.$t('Withdraw.rewardPercentageTxt2_1') + x.rechargeAmt + this.$t('Withdraw.rewardPercentageTxt2_2') + this.CurrencyType + x.handselRate
                        this.rewardPercentage2 = x.handselRate
                        this.rewardPercentageAmount2 = x.rechargeAmt
                    }
                    if (x.firstHandselRate && type === 'FirstReward') {
                        this.rewardPercentageTxt3 = this.$t('Withdraw.rewardPercentageTxt3_1') + x.rechargeAmt + this.$t('Withdraw.rewardPercentageTxt3_2') + this.CurrencyType + x.firstHandselRate
                        this.rewardPercentage3 = x.firstHandselRate
                        this.rewardPercentageAmount3 = x.rechargeAmt
                    }
                } else if (this.userInfo && this.userInfo.everyFirstRechargeState === 'No') {
                    if (x.everyHandselRate && type === 'EveryReward') {
                        this.rewardPercentageTxt1 = this.$t('Withdraw.rewardPercentageTxt1_1') + x.rechargeAmt + this.$t('Withdraw.rewardPercentageTxt1_2') + this.CurrencyType + x.everyHandselRate
                        this.rewardPercentage1 = x.everyHandselRate
                        this.rewardPercentageAmount1 = x.rechargeAmt
                    }
                    if (x.handselRate && type === 'Reward') {
                        this.rewardPercentageTxt2 = this.$t('Withdraw.rewardPercentageTxt2_1') + x.rechargeAmt + this.$t('Withdraw.rewardPercentageTxt2_2') + this.CurrencyType + x.handselRate
                        this.rewardPercentage2 = x.handselRate
                        this.rewardPercentageAmount2 = x.rechargeAmt
                    }
                } else {
                    if (x.everyHandselRate && type === 'EveryReward') {
                        this.rewardPercentageTxt1 = this.$t('Withdraw.rewardPercentageTxt1_1') + x.rechargeAmt + this.$t('Withdraw.rewardPercentageTxt1_2') + this.CurrencyType + x.everyHandselRate
                        this.rewardPercentage1 = x.everyHandselRate
                        this.rewardPercentageAmount1 = x.rechargeAmt
                    }
                }
                if (gratuityConditions === 'MAXIMUM') {
                    if (this.userInfo && this.userInfo.firstRechargeState === 'No') {
                        if (Number(x.firstHandselRate) >= Number(x.handselRate) && Number(x.firstHandselRate) >= Number(x.everyHandselRate)) {
                            this.rewardPercentage = Number(x.firstHandselRate || 0).toFixed(2)
                        }
                        if (Number(x.handselRate) >= Number(x.firstHandselRate) && Number(x.handselRate) >= Number(x.everyHandselRate)) {
                            this.rewardPercentage = Number(x.handselRate || 0).toFixed(2)
                        }
                        if (Number(x.everyHandselRate) >= Number(x.handselRate) && Number(x.everyHandselRate) >= Number(x.firstHandselRate)) {
                            this.rewardPercentage = Number(x.everyHandselRate || 0).toFixed(2)
                        }
                    } else if (this.userInfo && this.userInfo.everyFirstRechargeState === 'No') {
                        if (Number(x.handselRate) >= Number(x.everyHandselRate)) {
                            this.rewardPercentage = Number(x.handselRate || 0).toFixed(2)
                        }
                        if (Number(x.everyHandselRate) >= Number(x.handselRate)) {
                            this.rewardPercentage = Number(x.everyHandselRate || 0).toFixed(2)
                        }
                    } else {
                        this.rewardPercentage = Number(x.everyHandselRate || 0).toFixed(2)
                    }
                } else {
                    if (this.rewardPercentage1) {
                        this.rewardPercentage = (Number(this.rewardPercentage) + Number(this.rewardPercentage1 || 0)).toFixed(2)
                    }
                    if (this.rewardPercentage2) {
                        this.rewardPercentage = (Number(this.rewardPercentage) + Number(this.rewardPercentage2 || 0)).toFixed(2)
                    }
                    if (this.rewardPercentage3) {
                        this.rewardPercentage = (Number(this.rewardPercentage) + Number(this.rewardPercentage3 || 0)).toFixed(2)
                    }
                }
            } else {
                if (this.userInfo && this.userInfo.firstRechargeState === 'No') {
                    if (x.everyHandselRate && type === 'EveryReward') {
                        this.rewardPercentageTxt1 = this.$t('Withdraw.rewardPercentageTxt1_1') + x.rechargeAmt + this.$t('Withdraw.rewardPercentageTxt1_2') + x.everyHandselRate + this.$t('Withdraw.rewardPercentageTxt1_3')
                        this.rewardPercentage1 = x.everyHandselRate
                        this.rewardPercentageAmount1 = x.rechargeAmt
                    }
                    if (x.handselRate && type === 'Reward') {
                        this.rewardPercentageTxt2 = this.$t('Withdraw.rewardPercentageTxt2_1') + x.rechargeAmt + this.$t('Withdraw.rewardPercentageTxt2_2') + x.handselRate + this.$t('Withdraw.rewardPercentageTxt2_3')
                        this.rewardPercentage2 = x.handselRate
                        this.rewardPercentageAmount2 = x.rechargeAmt
                    }
                    if (x.firstHandselRate && type === 'FirstReward') {
                        this.rewardPercentageTxt3 = this.$t('Withdraw.rewardPercentageTxt3_1') + x.rechargeAmt + this.$t('Withdraw.rewardPercentageTxt3_2') + x.firstHandselRate + this.$t('Withdraw.rewardPercentageTxt3_3')
                        this.rewardPercentage3 = x.firstHandselRate
                        this.rewardPercentageAmount3 = x.rechargeAmt
                    }
                } else if (this.userInfo && this.userInfo.everyFirstRechargeState === 'No') {
                    if (x.everyHandselRate && type === 'EveryReward') {
                        this.rewardPercentageTxt1 = this.$t('Withdraw.rewardPercentageTxt1_1') + x.rechargeAmt + this.$t('Withdraw.rewardPercentageTxt1_2') + x.everyHandselRate + this.$t('Withdraw.rewardPercentageTxt1_3')
                        this.rewardPercentage1 = x.everyHandselRate
                        this.rewardPercentageAmount1 = x.rechargeAmt
                    }
                    if (x.handselRate && type === 'Reward') {
                        this.rewardPercentageTxt2 = this.$t('Withdraw.rewardPercentageTxt2_1') + x.rechargeAmt + this.$t('Withdraw.rewardPercentageTxt2_2') + x.handselRate + this.$t('Withdraw.rewardPercentageTxt2_3')
                        this.rewardPercentage2 = x.handselRate
                        this.rewardPercentageAmount2 = x.rechargeAmt
                    }
                } else {
                    if (x.everyHandselRate && type === 'EveryReward') {
                        this.rewardPercentageTxt1 = this.$t('Withdraw.rewardPercentageTxt1_1') + x.rechargeAmt + this.$t('Withdraw.rewardPercentageTxt1_2') + x.everyHandselRate + this.$t('Withdraw.rewardPercentageTxt1_3')
                        this.rewardPercentage1 = x.everyHandselRate
                        this.rewardPercentageAmount1 = x.rechargeAmt
                    }
                }
                if (gratuityConditions === 'MAXIMUM') {
                    if (this.userInfo && this.userInfo.firstRechargeState === 'No') {
                        if (Number(x.firstHandselRate) >= Number(x.handselRate) && Number(x.firstHandselRate) >=
                            Number(x.everyHandselRate)) {
                            this.rewardPercentage = (Number(rechargeValue || 0) / 100 * Number(x.firstHandselRate ||
                                0)).toFixed(2)
                        }
                        if (Number(x.handselRate) >= Number(x.firstHandselRate) && Number(x.handselRate) >= Number(x
                            .everyHandselRate)) {
                            this.rewardPercentage = (Number(rechargeValue || 0) / 100 * Number(x.handselRate || 0))
                                .toFixed(2)
                        }
                        if (Number(x.everyHandselRate) >= Number(x.handselRate) && Number(x.everyHandselRate) >=
                            Number(x.firstHandselRate)) {
                            this.rewardPercentage = (Number(rechargeValue || 0) / 100 * Number(x.everyHandselRate ||
                                0)).toFixed(2)
                        }
                    } else if (this.userInfo && this.userInfo.everyFirstRechargeState === 'No') {
                        if (Number(x.handselRate) >= Number(x.everyHandselRate)) {
                            this.rewardPercentage = (Number(rechargeValue || 0) / 100 * Number(x.handselRate || 0))
                                .toFixed(2)
                        }
                        if (Number(x.everyHandselRate) >= Number(x.handselRate)) {
                            this.rewardPercentage = (Number(rechargeValue || 0) / 100 * Number(x.everyHandselRate ||
                                0)).toFixed(2)
                        }
                    } else {
                        this.rewardPercentage = (Number(rechargeValue || 0) / 100 * Number(x.everyHandselRate || 0))
                            .toFixed(2)
                    }
                } else {
                    if (this.rewardPercentage1) {
                        this.rewardPercentage = (Number(this.rewardPercentage) + Number(Number(rechargeValue || 0) /
                            100 * Number(this.rewardPercentage1 || 0))).toFixed(2)
                    }
                    if (this.rewardPercentage2) {
                        this.rewardPercentage = (Number(this.rewardPercentage) + Number(Number(rechargeValue || 0) /
                            100 * Number(this.rewardPercentage2 || 0))).toFixed(2)
                    }
                    if (this.rewardPercentage3) {
                        this.rewardPercentage = (Number(this.rewardPercentage) + Number(Number(rechargeValue || 0) /
                            100 * Number(this.rewardPercentage3 || 0))).toFixed(2)
                    }
                }
            }
            if (repeatIsFreeRounds === 'Yes') this.rewardFS = x.freePayNumber
            else this.rewardFS = 0
        },
        handlePayListItemClick(item) {
            this.isShowPayList = false
            this.payListId = item.id
            this.payChannelType = item.payChannelType
            this.payListImg = item.imgUrl
            this.payListName = item.name || item.showName
            this.minRechargeAmt = item.minRechargeAmt || 0
            this.maxRechargeAmt = item.maxRechargeAmt || 0
        },
        handleRechargeChange() {
            this.getRewardPercentage()
        },
        handleListItemClick(item) {
            this.rechargeValue = item.rechargeAmt
            this.getRewardPercentage()
        },
        handleUsdtListItemClick(item) {
            this.usdtRechargeValue = item.rechargeAmt
            this.getRewardPercentage()
        },
        handleRecharge() {
            if (!this.payListId) return
            // if (this.canCallHandleRecharge) {
            //     this.$refs.payDetail.setMsg('123')
            //     // this.$refs.payDetail.open()
            //     return
            // }
            if (this.canCallHandleRecharge) {
                this.canCallHandleRecharge = false
                if (!this.rechargeValue) {
                    this.canCallHandleRecharge = true
                    Toast(this.$t('deposit.PleaseEnterDeposit'))
                    return
                }
                if (this.minRechargeAmt && Number(this.rechargeValue || 0) < Number(this.minRechargeAmt || 0)) {
                    this.canCallHandleRecharge = true
                    Toast(this.$t('deposit.isMinRechargeAmtTips'))
                    return
                }
                if (this.maxRechargeAmt && Number(this.rechargeValue || 0) > Number(this.maxRechargeAmt || 0)) {
                    this.canCallHandleRecharge = true
                    Toast(this.$t('deposit.isMaxRechargeAmtTips'))
                    return
                }
                const userAgent = navigator.userAgent
                const params = {
                    payChannelId: this.payListId,
                    orderAmt: this.rechargeValue,
                    yesNoType: this.showBonus ? 'Yes' : 'No',
                    userAgent
                }
                createMemberRechargeOrder(params, { custom: { toast: false } })
                    .then(res => {
                        if (res.code === 0 && !this.canCallHandleRecharge) {
                            if (this.payChannelType !== 'RuSuperPay') {
                                this.close()
                            }

                            this.canCallHandleRecharge = true
                            const url = res.result.payUrl
                            if (this.payChannelType === 'SupefinaPay') {
                                window.location.href = url
                            } else if (this.payChannelType === 'TurCodePay') {
                                window.location.href = url
                            } else if (this.payChannelType === 'WanguPay') {
                                window.location.href = url
                            } else if (this.payChannelType === 'RuSuperPay') {
                                this.$refs.payDetail.setMsg(url)
                            } else {
                                console.log(666555)
                                const encodedUrl = encodeURIComponent(url)
                                this.onNavTo({ url: '/depositWv', type: 'get', params: { url: encodedUrl } })
                            }
                        }
                        if (res.code !== 0) {
                            this.canCallHandleRecharge = true
                        }
                    }).catch(() => {
                        this.canCallHandleRecharge = true
                    }).finally(() => {
                        this.canCallHandleRecharge = true
                    })
            }
        },
        handleUsdtRecharge() {
            if (!this.payListId) return
            if (this.canCallHandleRecharge) {
                this.canCallHandleRecharge = false
                if (!this.usdtRechargeValue) {
                    this.canCallHandleRecharge = true
                    Toast(this.$t('deposit.PleaseEnterDeposit'))
                    return
                }
                if (this.minRechargeAmt && Number(this.usdtRechargeValue || 0) < Number(this.minRechargeAmt || 0)) {
                    this.canCallHandleRecharge = true
                    Toast(this.$t('deposit.isMinRechargeAmtTips'))
                    return
                }
                if (this.maxRechargeAmt && Number(this.usdtRechargeValue || 0) > Number(this.maxRechargeAmt || 0)) {
                    this.canCallHandleRecharge = true
                    Toast(this.$t('deposit.isMaxRechargeAmtTips'))
                    return
                }
                const userAgent = navigator.userAgent
                const params = {
                    payChannelId: this.payListId,
                    usdtOrderAmt: this.usdtRechargeValue,
                    yesNoType: this.showBonus ? 'Yes' : 'No',
                    userAgent
                }
                if (this.payChannelType !== 'USDTTRC20') {
                    const params2 = {
                        payChannelId: this.payListId,
                        orderAmt: this.usdtRechargeValue,
                        yesNoType: this.showBonus ? 'Yes' : 'No',
                        userAgent
                    }
                    createMemberRechargeOrder(params2, { custom: { toast: false } })
                        .then(res => {
                            if (res.code === 0 && !this.canCallHandleRecharge) {
                                if (this.payChannelType !== 'RuSuperPay') {
                                    this.close()
                                }
                                this.canCallHandleRecharge = true
                                const url = res.result.payUrl
                                if (this.payChannelType === 'SupefinaPay') {
                                    window.location.href = url
                                } else if (this.payChannelType === 'TurCodePay') {
                                    window.location.href = url
                                } else if (this.payChannelType === 'WanguPay') {
                                    window.location.href = url
                                } else if (this.payChannelType === 'RuSuperPay') {
                                    this.$refs.payDetail.setMsg(url)
                                } else {
                                    const encodedUrl = encodeURIComponent(url)
                                    this.onNavTo({ url: '/depositWv', type: 'get', params: { url: encodedUrl } })
                                }
                            }
                            if (res.code !== 0) {
                                this.canCallHandleRecharge = true
                            }
                        }).catch(() => {
                            this.canCallHandleRecharge = true
                        }).finally(() => {
                            this.canCallHandleRecharge = true
                        })
                    return
                }
                createMemberUsdtRechargeOrder(params)
                    .then(res => {
                        if (res.code === 0 && !this.canCallHandleRecharge) {
                            this.canCallHandleRecharge = true
                            this.onShowDetail(res.result)
                        }
                        if (res.code !== 0) {
                            Toast(res.message)
                            this.canCallHandleRecharge = true
                        }
                    }).catch(() => {
                        this.canCallHandleRecharge = true
                    }).finally(() => {
                        this.canCallHandleRecharge = true
                    })
            }
        },
        onShowDetail(item) {
            this.$nextTick(() => {
                this.depositDetails = item
                this.$refs.depositDetail.open()
            })
        },
        onContinueDeposit() {
            this.depositType = 'TransferDeposit'
        },
        toTutorial() {
            if (this.depositType === 'TransferDeposit') {
                getUsdtTutorials().then((res) => {
                    if (!res) return
                    if (res.code) return
                    const D = res.result
                    const obj = { eventName: this.$t('deposit.Tutorial'), eventContent: D }
                    const params = encodeURIComponent(JSON.stringify(obj))
                    const timestamp = new Date().getTime()
                    this.onNavTo({ url: 'PromotionCustom', type: 'post', params: { timestamp, params } })
                    this.close()
                })
            }
        },
        toTransaction() {
            this.$store.dispatch('user/setIsShowTransactionPopup', true)
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

$deposit-popup-tab-divider: $border-component-soft-color;
$deposit-popup-tab-muted-text: $font-component-slate-strong-color;
$deposit-popup-method-active-bg: $bg-component-neutral-color;
$deposit-popup-banner-button-text: $font-btn-color;
$deposit-popup-banner-highlight: $font-component-gold-base-color;
$deposit-popup-banner-detail-bg: rgba($bg-shell-color, .5);
$deposit-popup-input-base-bg: $bg-component-dark-color;
$deposit-popup-input-base-text: $font-component-surface-bright-color;
$deposit-popup-input-base-highlight: $font-component-gold-base-color;
$deposit-popup-exchange-muted: $font-component-field-color;
$deposit-popup-amount-active-bg: linear-gradient(180deg, $bg-component-panel-deep-color -1.09%, $bg-component-dark-color 97.83%);
$deposit-popup-rules-bg: rgba($border-component-active-blue-color, .2);
$deposit-popup-rules-table-border: $font-component-slate-strong-color;
$deposit-popup-mobile-main-bg: $bg-component-dark-color;
$deposit-popup-red-surface-bg: linear-gradient(180deg, rgba($bg-component-panel-deep-color, .98) 0%, rgba($bg-component-disabled-deep-color, .99) 100%);
$deposit-popup-red-card-bg: rgba($font-component-gold-pale-color, .06);
$deposit-popup-red-card-border: rgba($font-component-gold-base-color, .28);
$deposit-popup-red-card-active-bg: linear-gradient(180deg, rgba($bg-component-panel-deep-color, .98) 0%, rgba($bg-component-disabled-deep-color, .98) 100%);
$deposit-popup-red-form-border: rgba($font-component-gold-base-color, .36);
$deposit-popup-red-form-bg: linear-gradient(180deg, rgba($bg-component-panel-deep-color, .96) 0%, rgba($bg-component-disabled-deep-color, .98) 100%);
$deposit-popup-red-form-highlight: $font-component-gold-base-color;
$deposit-popup-red-button-text: $font-btn-color;
$deposit-popup-red-check: $font-component-gold-base-color;
$deposit-popup-red-rules-bg: rgba($bg-component-panel-deep-color, .42);
$deposit-popup-red-rules-border: rgba($font-component-hot-color, .24);
$deposit-popup-red-shell-highlight: radial-gradient(circle at 20% 0, rgba($font-component-hot-soft-color, .14) 0, rgba($font-component-hot-soft-color, 0) 30%);
$deposit-popup-red-shell-overlay: linear-gradient(180deg, rgba($font-title-color, .04) 0, rgba($font-title-color, 0) .24rem);
$deposit-popup-red-shell-border: rgba($font-component-hot-color, .24);
$deposit-popup-red-shell-shadow: 0 .18rem .36rem rgba($bg-shell-color, .3);
$deposit-popup-red-main-overlay: linear-gradient(180deg, rgba($font-title-color, .03) 0%, rgba($font-title-color, 0) .18rem);
$deposit-popup-red-main-bg: linear-gradient(180deg, rgba($bg-component-panel-deep-color, .78) 0%, rgba($bg-component-disabled-deep-color, .88) 100%);
$deposit-popup-red-banner-bg: $bg-component-danger-color;
$deposit-popup-red-banner-shadow: 0 .06rem .14rem rgba($bg-shell-color, .22);
$deposit-popup-red-tab-bg: rgba($font-component-gold-warm-color, .04);
$deposit-popup-red-tab-border: rgba($font-component-hot-color, .18);
$deposit-popup-red-tab-text: $font-component-gold-soft-color;
$deposit-popup-red-tab-active-bg: linear-gradient(90deg, rgba($font-component-hot-soft-color, .18) 0%, rgba($font-component-danger-strong-color, .14) 100%);
$deposit-popup-red-tab-active-shadow: inset 0 1px 0 rgba($font-component-gold-warm-color, .1);
$deposit-popup-red-input-overlay: linear-gradient(180deg, rgba($font-title-color, .03) 0%, rgba($font-title-color, 0) .12rem);
$deposit-popup-red-input-bg: linear-gradient(180deg, rgba($bg-component-panel-deep-color, .98) 0%, rgba($bg-component-disabled-deep-color, .99) 100%);
$deposit-popup-red-secondary-bg: linear-gradient(180deg, rgba($bg-component-panel-deep-color, .96) 0%, rgba($bg-component-disabled-deep-color, .98) 100%);
$deposit-popup-blue-shell-highlight: radial-gradient(circle at 20% 0, rgba($border-component-active-blue-color, .16) 0, rgba($border-component-active-blue-color, 0) 30%);
$deposit-popup-blue-shell-overlay: linear-gradient(180deg, rgba($font-component-cool-color, .04) 0, rgba($font-component-cool-color, 0) .24rem);
$deposit-popup-blue-shell-border: rgba($border-component-active-blue-color, .24);
$deposit-popup-blue-shell-shadow: 0 .18rem .36rem rgba($bg-shell-color, .28);
$deposit-popup-blue-main-overlay: linear-gradient(180deg, rgba($font-component-cool-color, .03) 0%, rgba($font-component-cool-color, 0) .18rem);
$deposit-popup-blue-main-bg: linear-gradient(180deg, rgba($bg-component-input-focus-color, .82) 0%, rgba($bg-component-dark-color, .9) 100%);
$deposit-popup-blue-card-border: rgba($border-component-active-blue-color, .22);
$deposit-popup-blue-card-bg: rgba($font-component-cool-color, .05);
$deposit-popup-blue-card-active-bg: linear-gradient(180deg, rgba($border-component-active-blue-color, .92) 0%, rgba($bg-component-input-focus-color, .98) 100%);
$deposit-popup-blue-card-active-border: $border-component-active-blue-color;
$deposit-popup-blue-tab-bg: rgba($font-component-cool-color, .04);
$deposit-popup-blue-tab-active-bg: linear-gradient(90deg, rgba($font-component-link-blue-color, .18) 0%, rgba($border-component-active-blue-color, .14) 100%);
$deposit-popup-blue-tab-active-shadow: inset 0 1px 0 rgba($font-component-cool-color, .08);
$deposit-popup-blue-input-overlay: linear-gradient(180deg, rgba($font-component-cool-color, .03) 0%, rgba($font-component-cool-color, 0) .12rem);
$deposit-popup-blue-input-bg: linear-gradient(180deg, rgba($bg-component-input-focus-color, .98) 0%, rgba($bg-component-dark-color, .99) 100%);
$deposit-popup-blue-input-placeholder: $font-component-slate-strong-color;
$deposit-popup-blue-form-bg: linear-gradient(180deg, rgba($bg-component-input-focus-color, .96) 0%, rgba($bg-component-dark-color, .98) 100%);
$deposit-popup-blue-highlight: $font-component-link-blue-color;
$deposit-popup-blue-primary-bg: $bg-component-cyan-accent-gradient-color;
$deposit-popup-blue-primary-text: $font-component-surface-white-color;
$deposit-popup-blue-primary-shadow: 0 .06rem .14rem rgba($bg-shell-color, .22);
$deposit-popup-blue-secondary-bg: linear-gradient(180deg, rgba($border-component-active-blue-color, .42) 0%, rgba($bg-component-input-focus-color, .98) 100%);
$deposit-popup-blue-rules-bg: rgba($bg-component-input-focus-color, .42);

.popup {
    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .content {
            background: $bg-popup-color;
            border-radius: .2rem;
            box-sizing: border-box;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 686px;
            position: relative;
            padding-left: 300px;

            .tab {
                height: .76rem;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                z-index: 3;
                cursor: pointer;
                border-bottom: .01rem solid $deposit-popup-tab-divider;
                margin-top: .1rem;

                &__item {
                    text-align: center;
                    color: $deposit-popup-tab-muted-text;
                    font-size: .24rem;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    line-height: .3rem;
                    margin-right: .48rem;
                    position: relative;
                    text-align: left;
                    height: 100%;

                    &>i {
                        margin-right: .15rem;
                        font-size: .34rem;
                    }

                    &.act {
                        color: $font-component-warning-color;

                        &:after {
                            content: '';
                            width: 100%;
                            height: .04rem;
                            background-color: $font-component-warning-color;
                            position: absolute;
                            bottom: -.02rem;
                            left: 0;
                        }
                    }
                }
            }

            .PaymentMethods {
                width: 300px;
                height: 100%;
                background: $bg-component-header-deep-color;
                padding: 20px 10px;
                position: absolute;
                z-index: 1;
                left: 0;
                top: 0;

                .DepositMethods-header {
                    display: flex;
                    align-items: center;
                    text-align: left;
                    padding: 8px 0;

                    &>img {
                        width: 30px;
                        height: 30px;
                        box-sizing: border-box;
                        margin-right: .14rem;
                    }

                    &>div {
                        &>div:first-child {
                            color: $font-component-info-muted-color;
                            font-size: .2rem;
                            line-height: .26rem;
                        }

                        &>div:last-child {
                            color: $font-title-color;
                            font-size: .25rem;
                            font-weight: 700;
                            line-height: .3rem;
                        }
                    }
                }

                .DepositMethods-box {
                    padding-top: 2px;

                    .DepositMethods-title {
                        text-align: left;
                        color: $font-title-color;
                        font-size: .25rem;
                        font-weight: bold;
                    }

                    .DepositMethods-list {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        gap: 10px;

                        .DepositMethods-item {
                            width: calc(50% - 5px);
                            border-radius: 12px;
                            background: $bg-component-panel-deep-color;
                            border-style: solid;
                            border-width: 1px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-direction: column;
                            height: 88px;
                            margin-top: 10px;
                            cursor: pointer;
                            position: relative;

                            &.act {
                                border-color: $border-component-active-blue-color;
                                background: $deposit-popup-method-active-bg;
                            }

                            &>img {
                                height: auto;
                                min-height: 38px;
                                width: 60px;
                                box-sizing: border-box;
                                background-color: $font-title-color;
                                border-radius: .05rem;
                                &.DepositMethods-item-hot{
                                    position: absolute;
                                    width: .6rem;
                                    height: auto;
                                    top: -.25rem;
                                    right: -.1rem;
                                    background-color: transparent;
                                    z-index: 6;
                                }
                            }

                            &>div {
                                color: $font-title-color;
                                font-size: 12px;
                                font-weight: 500;
                            }
                        }
                    }
                }
            }

            .Deposit {
                width: 500px;
                height: 100%;
                display: flex;
                flex-direction: column;

                .header {
                    display: flex;
                    height: 1rem;
                    padding-left: .46rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-top: .1rem;

                    &>div:first-child {
                        font-size: .32rem;
                        font-weight: bold;
                        color: $font-title-color;
                    }

                    .close {
                        color: $font-component-slate-color;
                        font-size: .36rem;
                        font-weight: bold;
                        height: 1rem;
                        width: 1rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                    }
                }

                .Deposit-main {
                    padding: 0 20px;
                    padding-bottom: 30px;
                    width: 100%;
                    flex: 1;
                    overflow: auto;
                    background: $bg-component-panel-deep-color;

                    .DepositContent {
                        position: relative;
                        z-index: 2;
                    }

                    .first-Deposit {
                        border-radius: 12px;
                        width: 100%;
                        background-image: url('@/assets/deposit/new_pay_banner_pc.jpg');
                        background-repeat: no-repeat;
                        background-size: cover;
                        height: 100px;
                        position: relative;
                        padding-left: 25px;
                        padding-bottom: 9px;
                        padding-top: 9px;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        justify-content: center;
                        overflow: hidden;

                        .btn {
                            color: $deposit-popup-banner-button-text;
                            background: $bg-component-reward-chip-color;
                            font-weight: 700;
                            border-radius: 100px;
                            cursor: auto;
                            padding: 5px 20px;
                            width: max-content;
                            font-size: 14px;
                            margin-bottom: 3px;
                            cursor: pointer;
                        }

                        .txt {
                            color: $font-title-color;
                            font-size: 14px;
                            text-align: left;
                            font-weight: bold;
                            line-height: 17px;

                            .val {
                                color: $deposit-popup-banner-highlight;
                            }
                        }

                        .detail {
                            color: $font-title-color;
                            background: $deposit-popup-banner-detail-bg;
                            position: absolute;
                            bottom: 0;
                            right: 0;
                            border-top-left-radius: 6px;
                            padding: 3px 15px;
                            cursor: pointer;
                        }
                    }

                    .PaymentMethods-App {
                        display: none;
                        margin-top: .16rem;

                        .DepositMethods-title {
                            text-align: left;
                            color: $font-title-color;
                            font-size: .24rem;
                            font-weight: bold;
                        }

                        .DepositMethods-selected {
                            width: 100%;
                            height: .9rem;
                            border-radius: .12rem;
                            background: $bg-component-panel-deep-color;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: .24rem;
                            margin-top: .1rem;

                            .info {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: .28rem;
                                color: $font-title-color;

                                &>img {
                                    height: auto;
                                    min-height: .38rem;
                                    width: .62rem;
                                    box-sizing: border-box;
                                    background-color: $font-title-color;
                                    border-radius: .05rem;
                                    margin-right: .15rem;
                                }
                            }

                            .change {
                                color: $font-component-warning-color;
                                font-weight: 500;
                                font-size: .24rem;
                            }
                        }
                    }

                    .amount_input {
                        .Recharge-Limt {
                            color: $font-component-info-muted-color;
                            font-size: 14px;
                            margin-top: 10px;
                            text-align: left;
                        }

                        ::v-deep input::-webkit-outer-spin-button {
                            -webkit-appearance: none;
                        }

                        ::v-deep input::-webkit-inner-spin-button {
                            -webkit-appearance: none;
                        }

                        ::v-deep input[type='number'] {
                            -moz-appearance: textfield;
                        }

                        ::v-deep .ant-input {
                            background-color: $deposit-popup-input-base-bg !important;
                            border-radius: 0.14rem;
                            font-size: 0.22rem;
                            height: 0.85rem;
                            padding: 0px 0.24rem !important;
                            color: $deposit-popup-input-base-text;
                            border: .02rem solid $border-component-dark-color !important;
                            padding-right: 2.8rem !important;

                            &:focus {
                                background-color: transparent;
                                border-color: $border-component-active-blue-color !important;
                            }

                            &::-webkit-input-placeholder {
                                /* WebKit browsers */
                                font-size: .22rem;
                                color: $font-component-slate-color;
                                opacity: .7;
                                font-weight: 100;
                            }

                            &:-moz-placeholder {
                                /* Mozilla Firefox 4 to 18 */
                                font-size: .22rem;
                                color: $font-component-slate-color;
                            }

                            &::-moz-placeholder {
                                /* Mozilla Firefox 19+ */
                                font-size: .22rem;
                                color: $font-component-slate-color;
                            }

                            &:-ms-input-placeholder {
                                /* Internet Explorer 10+ */
                                font-size: .22rem;
                                color: $font-component-slate-color;
                            }

                        }

                        ::v-deep .ant-input-suffix {
                            .extra {
                                color: $font-component-warning-color;
                                padding-right: .24rem;
                            }

                            .noBonus {
                                color: $deposit-popup-banner-highlight;
                                padding-right: .24rem;
                            }
                        }
                    }

                    .exchangeRate {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        padding: .08rem 0;

                        .exchangeRate_left {
                            color: $deposit-popup-exchange-muted;
                            font-size: .22rem;
                            line-height: .3rem;
                            text-align: left;

                            &>div:last-child {
                                color: $font-title-color;
                                display: flex;
                                align-items: center;
                                font-size: .22rem;
                                text-align: left;

                                &>span:last-child {
                                    color: $font-component-gold-base-color;
                                    font-size: .3rem;
                                    margin-left: .12rem;
                                }
                            }
                        }

                        .exchangeRate_right {
                            text-align: right;
                            color: $font-component-gold-bright-color;
                            font-weight: 700;
                            font-size: .24rem;
                        }
                    }

                    .form_gap {
                        display: flex;
                        gap: 9px;
                        cursor: pointer;
                        position: relative;
                        margin: .18rem 0;
                        flex-wrap: wrap;

                        .form_gap_item {
                            width: calc(33.33333% - 6px);
                            border-radius: .12rem;
                            box-sizing: border-box;
                            font-size: .24rem;
                            border: .01rem solid $border-component-dark-color;
                            padding: .1rem 0;
                            padding-top: .14rem;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-direction: column;

                            &.act {
                                border-color: $font-component-warning-color;
                                background: $deposit-popup-amount-active-bg;
                            }

                            .num {
                                color: $font-title-color;
                                font-weight: bold;
                                font-size: .3rem;
                                line-height: .32rem;
                            }

                            .extra {
                                font-size: .24rem;
                                color: $font-component-warning-color;
                                line-height: .24rem;
                            }
                            .hot{
                                position: absolute;
                                height: .5rem;
                                width: .5rem;
                                top: -.2rem;
                                left: -.15rem;
                            }
                        }
                    }

                    .submit-btn {
                        width: 100%;
                        font-size: .24rem;
                        height: .65rem;
                        text-align: center;
                        line-height: .65rem;
                        background-color: $font-component-warning-color;
                        color: $font-title-color;
                        font-weight: bold;
                        border-radius: .14rem;
                        cursor: pointer;

                        &.ant-btn {
                            border-color: transparent;
                        }

                        &.toTransaction {
                            background: $border-component-active-blue-color;
                            margin-top: .2rem;
                            margin-bottom: .1rem;
                        }
                    }

                    .showBonus {
                        display: flex;
                        align-items: flex-start;
                        justify-content: flex-start;
                        padding: .06rem 0;

                        .check-box {
                            margin-bottom: .01rem;
                            margin-right: .1rem;

                            &>i {
                                font-size: .3rem;
                                color: $border-component-active-blue-color;
                            }

                            &>i.checked {
                                color: $border-component-active-blue-color;
                            }
                        }
                    }

                    .tips {
                        color: $font-component-info-muted-color;
                        font-size: .22rem;
                        line-height: .38rem;
                        margin-top: 0.03rem;
                        text-align: left;
                    }
                }

                .rulesDesc {
                    color: $font-title-color;
                    background: $deposit-popup-rules-bg;
                    border-radius: 12px;
                    width: 100%;
                    padding: 10px;
                    box-sizing: border-box;
                    text-align: left;
                    white-space: pre-line;

                    ::v-deep table {
                        width: 100% !important;
                        border-collapse: collapse;
                        /* 使得边框合并为单一边框 */
                    }

                    ::v-deep table {
                        border: 1px solid $deposit-popup-rules-table-border;
                        /* 设置表格、表头、单元格的边框 */
                    }

                    ::v-deep th {
                        border: 1px solid $deposit-popup-rules-table-border;
                        /* 设置表格、表头、单元格的边框 */
                    }

                    ::v-deep td {
                        border: 1px solid $deposit-popup-rules-table-border;
                        /* 设置表格、表头、单元格的边框 */
                    }

                    ::v-deep td {
                        // padding: 8upx 15upx ;
                    }
                }
            }
        }
    }

    &.mobile {
        // width: 100% !important;
        // height: 100% !important;

        .van-popup {
            &.van-popup--center {
                top: 0;
                left: 0;
                transform: translate3d(0, 0, 0);
                width: 100% !important;
                height: 100% !important;
            }
        }

        .content {
            width: 100% !important;
            height: 100% !important;
            padding-left: 0 !important;

            .Deposit {
                width: 100% !important;

                .header {
                    padding-left: .24rem !important;
                }

                .Deposit-main {
                    padding: 0 .24rem !important;
                    background: $deposit-popup-mobile-main-bg !important;
                    position: relative;
                    z-index: 2;

                    .DepositContent {
                        &.hide {
                            display: none;
                            z-index: 1;
                        }
                    }

                    .first-Deposit {
                        height: 1.52rem !important;
                        padding-left: .45rem !important;

                        .btn {
                            padding: .045rem .45rem;
                        }

                        .txt {
                            font-size: .22rem;
                        }
                    }

                    // .PaymentMethods-App {
                    //     display: block;
                    // }
                }
            }
        }

        .PaymentMethods {
            display: block;
            background: $bg-component-panel-deep-color;
            position: relative !important;
            left: auto;
            // top: 1.52rem !important;
            width: 100% !important;
            height: auto !important;
            padding: .12rem 0 !important;
            padding-bottom: .08rem;

            .DepositMethods-header{
                display: none !important;
            }
            .DepositMethods-box{
                .DepositMethods-list{
                    gap: .1rem !important;
                    .DepositMethods-item{
                        margin-top: 0 !important;
                    }
                }
            }

            &.act {
                display: block;
                z-index: 3;
            }
        }
    }
}

.content,
.Deposit,
.PaymentMethods {
    .Deposit .header .close {
        color: $font-component-gold-soft-color;
    }

    .Deposit .Deposit-main,
    & {
        background: $deposit-popup-red-surface-bg !important;
    }

    .DepositMethods-list .DepositMethods-item {
        background: $deposit-popup-red-card-bg;
        border-color: $deposit-popup-red-card-border;
    }

    .DepositMethods-list .DepositMethods-item.act {
        background: $deposit-popup-red-card-active-bg;
        border-color: $font-component-gold-strong-color;
    }

    .amount_input .Recharge-Limt {
        color: $font-component-gold-deep-color;
    }

    .form_gap .form_gap_item {
        border-color: $deposit-popup-red-form-border;
        background: $deposit-popup-red-form-bg;

        &.act {
            border-color: $font-component-gold-strong-color;
            background: $deposit-popup-red-card-active-bg;
        }

        .extra {
            color: $deposit-popup-red-form-highlight;
        }
    }

    .submit-btn {
        background: $bg-component-gold-button-color;
        color: $deposit-popup-red-button-text;

        &.toTransaction {
            background: $deposit-popup-red-secondary-bg;
            color: $font-component-gold-ivory-color;
        }
    }

    .showBonus .check-box > i {
        color: $deposit-popup-red-check;
    }

    .tips,
    .rulesDesc {
        color: $font-component-gold-deep-color;
    }

    .rulesDesc {
        background: $deposit-popup-red-rules-bg;
        border: 1px solid $deposit-popup-red-rules-border;
    }
}

.popup {
    .van-popup {
        background:
            $deposit-popup-red-shell-highlight,
            $deposit-popup-red-shell-overlay,
            $bg-component-red-deep-gradient-color !important;
        border: 1px solid $deposit-popup-red-shell-border;
        box-shadow: $deposit-popup-red-shell-shadow;
    }
}

.content,
.Deposit,
.PaymentMethods {
    .Deposit .header,
    .header {
        color: $font-component-gold-cream-color;

        .close {
            color: $font-component-gold-cream-color;
        }
    }

    .Deposit-main,
    .PaymentMethods,
    .DepositContent {
        background:
            $deposit-popup-red-main-overlay,
            $deposit-popup-red-main-bg !important;
    }

    .first-Deposit {
        .btn {
            background: $deposit-popup-red-banner-bg !important;
            color: $font-component-gold-ivory-soft-color !important;
            box-shadow: $deposit-popup-red-banner-shadow;
        }

        .txt,
        .detail {
            color: $font-component-gold-cream-color !important;
        }
    }

    .tab {
        background: $deposit-popup-red-tab-bg;
        border-color: $deposit-popup-red-tab-border !important;

        .tab__item {
            color: $deposit-popup-red-tab-text !important;

            &.act {
                color: $font-component-gold-cream-color !important;
                background: $deposit-popup-red-tab-active-bg;
                box-shadow: $deposit-popup-red-tab-active-shadow;
            }
        }
    }

    .DepositMethods-header,
    .DepositMethods-selected,
    .DepositMethods-box,
    .exchangeRate,
    .rulesDesc {
        border-color: $deposit-popup-red-tab-border !important;
    }

    .DepositMethods-title,
    .DepositMethods-header,
    .exchangeRate_left,
    .tips,
    .Recharge-Limt,
    .showBonus .tips,
    .rulesDesc {
        color: $deposit-popup-red-tab-text !important;
    }

    ::v-deep .ant-input {
        background:
            $deposit-popup-red-input-overlay,
            $deposit-popup-red-input-bg !important;
        border-color: $deposit-popup-red-shell-border !important;
        color: $font-component-gold-cream-color !important;

        &::placeholder,
        &::-webkit-input-placeholder {
            color: $deposit-popup-red-tab-text !important;
        }
    }

    ::v-deep .ant-input-suffix .extra,
    ::v-deep .ant-input-suffix .noBonus,
    .exchangeRate_right,
    .DepositMethods-selected .change,
    .DepositMethods-selected .info,
    .PaymentMethods .DepositMethods-item.act > div,
    .form_gap .form_gap_item .num {
        color: $font-component-gold-cream-color !important;
    }

    .submit-btn {
        background: $deposit-popup-red-banner-bg !important;
        color: $font-component-gold-ivory-soft-color !important;
        box-shadow: $deposit-popup-red-banner-shadow;

        &.toTransaction {
            background: $deposit-popup-red-secondary-bg !important;
        }
    }
}

.popup {
    .van-popup {
        background:
            $deposit-popup-blue-shell-highlight,
            $deposit-popup-blue-shell-overlay,
            $bg-component-blue-deep-gradient-color !important;
        border: 1px solid $deposit-popup-blue-shell-border;
        box-shadow: $deposit-popup-blue-shell-shadow;
    }
}

.content,
.Deposit,
.PaymentMethods {
    .Deposit .header,
    .header {
        color: $font-component-cool-color;

        .close {
            color: $font-component-cool-color;
        }
    }

    .Deposit .Deposit-main,
    .Deposit-main,
    .PaymentMethods,
    .DepositContent,
    & {
        background:
            $deposit-popup-blue-main-overlay,
            $deposit-popup-blue-main-bg !important;
    }

    .DepositMethods-list .DepositMethods-item,
    .DepositMethods-selected,
    .DepositMethods-box,
    .exchangeRate,
    .rulesDesc,
    .tab {
        border-color: $deposit-popup-blue-card-border !important;
    }

    .DepositMethods-list .DepositMethods-item {
        background: $deposit-popup-blue-card-bg;
    }

    .DepositMethods-list .DepositMethods-item.act {
        background: $deposit-popup-blue-card-active-bg;
        border-color: $deposit-popup-blue-card-active-border;
    }

    .tab {
        background: $deposit-popup-blue-tab-bg;
    }

    .tab .tab__item,
    .DepositMethods-title,
    .DepositMethods-header,
    .exchangeRate_left,
    .tips,
    .Recharge-Limt,
    .showBonus .tips,
    .rulesDesc,
    .first-Deposit .txt,
    .first-Deposit .detail {
        color: $font-component-cool-muted-color !important;
    }

    .tab .tab__item.act {
        color: $font-component-cool-color !important;
        background: $deposit-popup-blue-tab-active-bg;
        box-shadow: $deposit-popup-blue-tab-active-shadow;
    }

    ::v-deep .ant-input {
        background:
            $deposit-popup-blue-input-overlay,
            $deposit-popup-blue-input-bg !important;
        border-color: $deposit-popup-blue-shell-border !important;
        color: $font-component-cool-color !important;
    }

    ::v-deep .ant-input::placeholder,
    ::v-deep .ant-input::-webkit-input-placeholder {
        color: $deposit-popup-blue-input-placeholder !important;
    }

    ::v-deep .ant-input-suffix .extra,
    ::v-deep .ant-input-suffix .noBonus,
    .exchangeRate_right,
    .DepositMethods-selected .change,
    .DepositMethods-selected .info,
    .PaymentMethods .DepositMethods-item.act > div,
    .form_gap .form_gap_item .num {
        color: $font-component-cool-color !important;
    }

    .form_gap .form_gap_item {
        border-color: $deposit-popup-blue-shell-border;
        background: $deposit-popup-blue-form-bg;
    }

    .form_gap .form_gap_item.act {
        border-color: $deposit-popup-blue-card-active-border;
        background: $deposit-popup-blue-card-active-bg;
    }

    .form_gap .form_gap_item .extra,
    .showBonus .check-box > i {
        color: $deposit-popup-blue-highlight;
    }

    .submit-btn,
    .first-Deposit .btn {
        background: $deposit-popup-blue-primary-bg !important;
        color: $deposit-popup-blue-primary-text !important;
        box-shadow: $deposit-popup-blue-primary-shadow;
    }

    .submit-btn.toTransaction {
        background: $deposit-popup-blue-secondary-bg !important;
        color: $font-component-cool-color !important;
    }

    .rulesDesc {
        background: $deposit-popup-blue-rules-bg;
    }
}
</style>
